module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/v2/partenariat3-deef4d5ab1ddb85dd84f69701247469b.jpg";